import { View, Text, Dimensions, TouchableOpacity, Image } from "react-native";
import React from "react";
import MyText from "../custom/MyText";
import BabyIcon from "../../assets/svg/BabyIcon";
import { danger, gray, primary, white } from "../../colors";
import StepSlide from "../animation/StepSlide";
import { useState } from "react";
import PersonIcon from "../../assets/svg/PersonIcon";
import translate from "../../functions/translate";
import MyButton from "../custom/MyButton";
import { Feather } from "@expo/vector-icons";
import { babyBoy, babyGirl } from "../../imports";
import CalendarIcon from "../../assets/svg/CalendarIcon";

import PlayIcon from "../../assets/svg/PlayIcon";
import { useNavigation } from "@react-navigation/native";
import addNewTest from "../../api/test/addNewTest";

function Participated(props) {
  const navigation = useNavigation();
  return (
    <View
      style={{
        width: "100%",
        padding: 5,
        flexDirection: "row",
      }}
    >
      <View style={{ flexDirection: "row", alignItems: "center" }}>
        <View
          style={{
            marginHorizontal: 6,
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: white,
            borderRadius: 20,
            padding: 3,
          }}
        >
          <Image
            source={{ uri: props.image }}
            defaultSource={props.childGender === "male" ? babyBoy : babyGirl}
            style={{ width: 25, height: 25 }}
            resizeMode="contain"
          />
        </View>

        <MyText style={{ fontSize: 13, color: gray }}>
          {translate(
            props.childGender === "male" ? "your son" : "your daughter"
          )}
        </MyText>
        <MyText
          style={{
            fontSize: 13,
            color: gray,
            marginHorizontal: 2,
            maxWidth: 50,
          }}
        >
          {props.childName}
        </MyText>
      </View>

      <View style={{ flex: 1 }}></View>

      <View style={{ flexDirection: "row", alignItems: "center" }}>
        {/* <MyText style={{ marginHorizontal: 1, color: gray }}>3</MyText>
            <MyText style={{ marginHorizontal: 1, color: gray }}>
              {translate("test")}
            </MyText>
            <MyText style={{ marginHorizontal: 1, color: gray }}>
              {translate("from")}
            </MyText>
            <MyText style={{ marginHorizontal: 1, color: gray }}>5</MyText>
            <MyText style={{ marginHorizontal: 1, color: gray }}>
              {translate("test")}
            </MyText> */}
        {/* <MyText style={{ marginHorizontal: 1, color: gray }}>
          {translate("not completed")}
        </MyText> */}
        <MyButton
          onPress={() =>
            navigation.navigate("GrowthTestSelect", {
              childName: props.childName,
              childGender: props.childGender,
              childId: props.childId,
              childImage: props.childImage,
              type: "growth",
            })
          }
          text={translate("do test")}
        />
        {/* <TouchableOpacity
          onPress={() =>
            navigation.navigate("GrowthTestSelect", {
              childName: props.childName,
              childGender: props.childGender,
              childId: props.childId,
              type:'growth',
            })
          }
          style={{
            width: 30,
            height: 30,
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#eee",
            borderRadius: 15,
            marginHorizontal: 4,
          }}
        >
          <PlayIcon />
        </TouchableOpacity> */}
      </View>
    </View>
  );
}
export default function GrowthTestItem(props) {
  //   const { image, type, age, id, gender, dateEnd, name } = props;
  //   const testTitle = "";
  const navigation = useNavigation();
  return (
    <TouchableOpacity
      onPress={() =>
        navigation.navigate("GrowthTestSelect", {
          childName: props.name,
          childGender: props.gender,
          childId: props.childId,
          childImage: props.childImage,
          type: "growth",
        })
      }
      activeOpacity={1}
      style={{
        width: "98%",
        borderRadius: 10,
        backgroundColor: "#DEE1FF",
        padding: "2%",
        overflow: "hidden",
        minHeight: 70,
        marginVertical: 5,
      }}
    >
      <View style={{ flexDirection: "row" }}>
        <MyText style={{ fontSize: 20, marginHorizontal: 3 }}>{`${translate(
          "grow test"
        )}`}</MyText>
        <View style={{ flex: 1 }}></View>
        <View style={{ flexDirection: "row", alignItems: "center" }}>
          <BabyIcon />
          {/* <MyText style={{ marginHorizontal: 2, color: gray, fontSize: 13 }}>
            {`${age}`}
          </MyText>
          <MyText style={{ fontSize: 13, color: gray }}>
            {translate("monthy")}
          </MyText> */}
        </View>
      </View>
      <View style={{ flex: 1 }}></View>

    
    </TouchableOpacity>
  );
}
